var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c("YDSearchForm", {
        attrs: {
          "form-items": _vm.searchFormItems,
          "initial-values": _vm.initVals,
          permi: "user_advertising_edit",
        },
        on: {
          search: _vm.handleSearch,
          reset: _vm.handleReset,
          add: _vm.handleAdd,
        },
      }),
      _c(
        "yd-table",
        {
          ref: "advertisingTable",
          attrs: {
            data: _vm.records,
            pagination: _vm.pagination,
            loading: _vm.loading,
            "span-method": _vm.handleSpanMethod,
          },
          on: { onChange: _vm.onTableChange },
        },
        [
          _c("el-table-column", {
            attrs: { label: "模板", prop: "adTemplateName", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "名称", prop: "name", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-link",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.viewDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.name))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "banner位置", prop: "slotKey", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.getBannerPosition({ slotKey: scope.row.slotKey })
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "状态", prop: "status", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.renderStatusTag(scope.row.status).type,
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.renderStatusTag(scope.row.status).text) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "创建人", prop: "createUserName", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "创建时间", prop: "createTime", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              prop: "operate",
              align: "center",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status !== 4
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["user_advertising_edit"],
                                expression: "['user_advertising_edit']",
                              },
                            ],
                            staticClass: "edit-button",
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.editBanner(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        )
                      : _vm._e(),
                    scope.row.status === 0
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["user_advertising_submitAudit"],
                                expression: "['user_advertising_submitAudit']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.changeStatus(0, scope.row)
                              },
                            },
                          },
                          [_vm._v("提交审核")]
                        )
                      : _vm._e(),
                    scope.row.status === 1
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["user_advertising_review"],
                                expression: "['user_advertising_review']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.changeStatus(1, scope.row)
                              },
                            },
                          },
                          [_vm._v("通过")]
                        )
                      : _vm._e(),
                    scope.row.status === 1
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["user_advertising_review"],
                                expression: "['user_advertising_review']",
                              },
                            ],
                            staticClass: "danger-button",
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.changeStatus(2, scope.row)
                              },
                            },
                          },
                          [_vm._v("不通过")]
                        )
                      : _vm._e(),
                    scope.row.status === 4
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["user_advertising_status"],
                                expression: "['user_advertising_status']",
                              },
                            ],
                            staticClass: "danger-button",
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.changeStatus(4, scope.row)
                              },
                            },
                          },
                          [_vm._v("下架")]
                        )
                      : _vm._e(),
                    scope.row.status === 5
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["user_advertising_status"],
                                expression: "['user_advertising_status']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.changeStatus(3, scope.row)
                              },
                            },
                          },
                          [_vm._v("上架")]
                        )
                      : _vm._e(),
                    scope.row.status === 0
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["user_advertising_delete"],
                                expression: "['user_advertising_delete']",
                              },
                            ],
                            staticClass: "danger-button",
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.onDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm.editVisible
        ? _c("DefaultBanner", {
            attrs: { visible: _vm.editVisible },
            on: {
              "update:visible": function ($event) {
                _vm.editVisible = $event
              },
              closeDialog: _vm.closeDialog,
            },
            model: {
              value: _vm.infoData,
              callback: function ($$v) {
                _vm.infoData = $$v
              },
              expression: "infoData",
            },
          })
        : _vm._e(),
      _c("BannerDetail", { ref: "bannerDetail" }),
      _c("RejectDialog", {
        attrs: {
          visible: _vm.rejectDialogVisible,
          bannerId: _vm.currentBanner ? _vm.currentBanner.id : "",
        },
        on: {
          "update:visible": function ($event) {
            _vm.rejectDialogVisible = $event
          },
          confirm: _vm.handleRejectConfirm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }